// extracted by mini-css-extract-plugin
export default {"button":"BurgerButton_button__zUCJ8","open":"BurgerButton_open__Dv2yS"};